/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyRegistrationStatus = {
  type: 'Enum',
} as const;
